import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import Search from './Search'
import Links, { Hamburger } from './Links'
import Headroom from 'headroom.js'

import * as styles from './mainheader.module.scss'

const src = '../images/medicine_and_the_military.png'

const MainHeader = () => {
  const [open, setOpen] = useState(false)
  const [activeLinkItem, setActiveLinkItem] = useState(null)
  const navbar = React.useRef(null)

  useEffect(() => {
    const options = {
      //   // vertical offset in px before element is first unpinned
      offset: 205,
      //   // scroll tolerance in px before state changes
      tolerance: 0,
    }

    const headroom = new Headroom(navbar.current.children[0], options)
    headroom.init()
  }, [])

  return (
    <div id="main-header" className={styles['wrap']} ref={navbar}>
      <div className={styles['inner']}>
        <Link to="/" className={styles['logo'] + ' icon-logo'}>
          <StaticImage src={src} height={18} placeholder="none" loading="eager" alt="Medicine and the Military logo" />
        </Link>
        <ul className={styles['utilities']}>
          <li className='faq'>
            <Link to="/military-physician-faq">FAQs</Link>
          </li>
          <li>|</li>
          <li className='nav-contact'>
            <Link to="/contact-a-recruiter">CONTACT A RECRUITER</Link>
          </li>
        </ul>
        <div className={styles['search']}>
          <Search />
        </div>
        <div className={styles['menu'] + ' navbar-collapse'}>
          <Hamburger open={open} setOpen={setOpen} />
          <Links open={open} activeLinkItem={activeLinkItem} setActiveLinkItem={setActiveLinkItem} />
        </div>
      </div>
    </div>
  )
}

export default MainHeader
